/* global Messenger */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey as getQueryKeyCriterias } from './useCriterias';

// Config
import { uiConfig, crudConfig } from '../../../conf/criteria';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CRITERIA);

export const useDeleteCriteria = ({ sessionToken, onSuccessCb, onErrorCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: (criteriaId) => Client.delete(sessionToken, criteriaId),
        onSuccess: (data) => {
            Messenger.showMessage({
                type: `success`,
                title: 'Criteria has been successfully deleted.'
            });
            updateCacheArray({
                queryKey: getQueryKeyCriterias(),
                action: CACHE_ACTIONS.REMOVE,
                primaryKey: uiConfig.primaryKey,
                data
            });
            onSuccessCb?.();
        },
        onError: (error) => {
            console.log('Error', error);
            const mtsErrMessage = error?.response?.data?.propertyMap?.message ?? error;

            if (typeof mtsErrMessage === 'string') {
                Messenger.showMessage({
                    type: `error`,
                    title: mtsErrMessage
                });
            }
            onErrorCb?.(error);
        },
        refetchOnWindowFocus: false
    });
};
